export enum BusinessModelEnum {
  Apparel = 10,
  Textile = 20,
}
